import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { push } from 'connected-react-router';

import { ApiErrorAction, AUTH_TYPES } from './authTypes';
import { AuthApi } from '../api/authApi';
import * as Actions from '../redux/authActions';
import { API_STATUS_CODE } from '../../enums/apiStatusCode';
import { MeGetResponse } from '../model/authModel';
import { ROUTES } from '../../router/routes';
import { API_REQUEST_STATE } from '../../enums/apiRequestState';

function* apiErrorSaga(apiError: ApiErrorAction) {
  switch (apiError.payload.errorCode) {
    case API_STATUS_CODE.UNAUTHORIZED:
      yield put(Actions.setIsAuthenticated(false));
      yield put(push(ROUTES.ERROR_401));
      break;
    case API_STATUS_CODE.FORBIDDEN:
      yield put(Actions.setIsAuthenticated(false));
      yield put(push(ROUTES.ERROR_403));
      break;
  }
}

function* getMeSaga() {
  try {
    yield put(Actions.setApiMeRequestState(API_REQUEST_STATE.LOADING));

    const response: AxiosResponse<MeGetResponse> = yield call(AuthApi.getMe);

    yield put(Actions.getMeSuccess(response.data));
    yield put(Actions.setApiMeRequestState(API_REQUEST_STATE.SUCCEEDED_GET));
  } catch (error) {
    yield put(Actions.getMeError());
    yield put(Actions.setApiMeRequestState(API_REQUEST_STATE.FAILED));
    // @ts-ignore
    if (!error.response) {
      yield put(push(ROUTES.ERROR_503));
    }
    // @ts-ignore
    console.log('SAGA ERROR', error.response);
  }
}

export default function* watch() {
  yield* [takeLatest(AUTH_TYPES.API_ERROR, apiErrorSaga), takeLatest(AUTH_TYPES.GET_ME, getMeSaga)];
}
